// export const rootUrl = "/api";
export const rootUrl = "https://dynote.herokuapp.com/api";
export const firebaseWebConfigB64 =
  "eyJhcGlLZXkiOiJBSXphU3lCcllYb2YwZlRfalhnZVRya25OQXliNVV2eDFxVDBoZFkiLCJhdXRoRG9tYWluIjoiZHlub3RlLTk2MDlmLmZpcmViYXNlYXBwLmNvbSIsInByb2plY3RJZCI6ImR5bm90ZS05NjA5ZiIsInN0b3JhZ2VCdWNrZXQiOiJkeW5vdGUtOTYwOWYuYXBwc3BvdC5jb20iLCJtZXNzYWdpbmdTZW5kZXJJZCI6Ijk1NTgyMDcyNjM3NCIsImFwcElkIjoiMTo5NTU4MjA3MjYzNzQ6d2ViOjZjNGMzNGM5MGM1ZjEwODcwYWI1YTcifQ==";
